import SignalFormPageContent from "./SignalFormPageContent";
import { SignalFormProvider } from "./signal-form-store";

import { Signal } from "@/queries/signals";

interface SignalFormPageProps {
  mode: "create" | "edit";
  signal?: Signal;
}

const SignalFormPage = ({ mode, signal }: SignalFormPageProps) => (
  <SignalFormProvider initialSignal={signal}>
    <div className="flex h-full min-h-0 flex-col">
      <SignalFormPageContent mode={mode} signal={signal} />
    </div>
  </SignalFormProvider>
);

export default SignalFormPage;
